<template>
	<!-- 小店申请 -->
	<cube-page title="小店申请">
		<div slot="content">
			<div class="shopxq leopages">
				<van-form @submit="onSubmit">
					<van-field v-model="entry.storename" clearable label="小店名称" placeholder="小店名称" name="storename"
						required :rules="[{ required: true, message: '请填写小店名称' }]" />
					<van-field v-model="entry.mobile" type="tel" clearable label="手机号码" placeholder="手机号码" name="mobile"
						required :rules="[{ required: true, message: '请填写手机号码' }]" />
					<van-field v-model="entry.contacts" clearable label="联系人" placeholder="小店联系人" name="contacts"
						required :rules="[{ required: true, message: '请填写小店联系人' }]" />
					<van-field v-model="entry.address" clearable label="地址" placeholder="小店地址" name="address" required
						:rules="[{ required: true, message: '请填写小店地址' }]" />
					<van-field v-model="entry.notice" clearable rows="1" autosize label="店宣" type="textarea"
						name="notice" placeholder="请输入店宣" required :rules="[{ required: true, message: '请输入店宣' }]" />
					<van-field name="avatar" label="头像" required after-read="onRead"
						:rules="[{ required: true, message: '请上传头像' }]">
						<template #input>
							<van-uploader v-model="entry.avatar" :max-count="1" />
						</template>
					</van-field>
					<div style="margin: 16px;">
						<van-button round block type="info" native-type="submit">提交</van-button>
					</div>
				</van-form>
			</div>
		</div>
	</cube-page>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage,
		},
		data() {
			return {
				item: this.$route.params.item,
				entry: {
					storename: '',
					address: '',
					contacts: '',
					mobile: '',
					notice: '',
					avatar: []
				}
			}
		},
		created() {},
		methods: {
			onSubmit(values) {
				console.log('submit', values);
				var url = "/addons/litestore/api.store/add"
				let that = this;
				var pram = {
					row: {
						storename: that.entry.storename,
						address: that.entry.address,
						contacts: that.entry.contacts,
						mobile: that.entry.mobile,
						notice: that.entry.notice,
						avatar: that.compress(that.entry.avatar[0])
					}
				};
				console.log(pram)
				//这里直接调用网络接口
				util.post(url, pram,
					function(result) {
						console.log('result', result);
					},
				);
			},
			onRead(file) {
				console.log('onRead', file)
				let that = this;
				let img = new Image();
				img.src = file.content
				let reader = new FileReader();
				reader.readAsDataURL(file.file);
				let id_card = that.compress(img);
				console.log('id_card', id_card)
			},
			// 压缩图片
			compress(file) {
				let img = new Image();
				img.src = file.content
				let url = '';
				var w = Math.min(700, img.width); //当图片像素 > 700 时   等比例压缩   这个数字可以调
				var h = img.height * (w / img.width);
				var canvas = document.createElement('canvas');
				var ctx = canvas.getContext('2d');
				canvas.width = w;
				canvas.hight = h;
				ctx.drawImage(img, 0, 0, w, h);
				url = canvas.toDataURL('image/png', 1); //1代表精细度 越高越好
				return url;
			}
		}

	}
</script>
 